import React, { Component } from 'react';

import { Mixpanel } from './Mixpanel';

import settings from '../data/settings_meresankh_zh-hans.json';
import translations from '../data/translations.json';


interface Props {
}

interface State {
  formState: string;
  email: string;
}

export class EmailSignup extends Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.state = {
      formState: "clean",
      email: "",
    };
  }

  handleChange(e) {
    this.setState({
      email: e.target.value,
    });
  }

  async handleSubmit (e) {
    const { email } = this.state;
    e.preventDefault();

    await this.setState({
      formState: "sending",
    });

    // user signed up
    Mixpanel.track('User signed up inside a Guided tour', { hostname: settings.slug, email, });
    console.log("email", email);
    console.log(JSON.stringify({
          email,
        }))

    try {
      const res = await fetch('https://mused.org/en/m-api/user-signup', {
      // const res = await fetch('http://mused.local:8000/en/m-api/user-signup', {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          email,
        }),
      });
      const data = res.json();
      console.log(res);

      if (res.status === 404) {
        await this.setState({
          formState: "error",
        });
      } else {
        await this.setState({
          formState: "sent",
        });
      }

    } catch(err) {
      console.error(err);
      await this.setState({
        formState: "error",
      });
    }
  }

  render() {
    const { formState } = this.state;

    return (
      <div className="bg-theme-700 pointer-events-auto">
        {(formState === "sent") ?
          <div className="p-6">
            <span className="text-xl text-white block">
              {translations[settings.language]['Thanks for signing up! We’ll stay in touch with future updates about the project.']}
            </span>
          </div>
        :
          <form onSubmit={this.handleSubmit.bind(this)} className="p-6">
            <label htmlFor="email" className="block text-white text-base sm:text-lg">
              {formState === "error" ?
                <span>
                  Sorry, there was an error signing you up. Please try again in a few hours or contact <a href="mailto:hello@mused.org" className="underline hover:no-underline">hello@mused.org</a>.
                </span>
              :
                <span>
                  {settings.signup_message}
                </span>
              }

            </label>
            <div className="flex flex-nowrap w-full pt-1">
              <input
                id="email"
                type="email"
                name="email"
                placeholder={settings.signup_email_placeholder}
                className="block text-sm sm:text-lg p-2 text-black"
                style={{ height: "3rem" }}
                onChange={this.handleChange.bind(this)}
                required
              />
              <button type="submit" className="block bg-theme-800 hover:bg-theme-900 font-sans font-base h-full py-2 px-4 text-white flex items-center justify-center"  style={{ height: "3rem"}}>
                {(formState === "sending") ?
                    <div className="lds-ellipsis block"><div></div><div></div><div></div><div></div></div>
                :
                  translations[settings.language]['Sign up']
                }
              </button>
            </div>
          </form>
        }
      </div>
    );
  }
}
